import {
  Flex,
  Icon,
  PlacementWithLogical,
  Text,
  Tooltip,
} from "@chakra-ui/react";
import { FaTimesCircle } from "react-icons/fa";
import { SUPPORTED_CHAINS } from "~/core/constants";
import { ProjectDocument, SupportedChains } from "~/core/types";
import RequiredIndicator from "../RequiredIndicator";

export default function WalletBalanceRequirement({
  project,
  isTooltipOpen,
  tooltipPosition,
  tooltipLabel,
}: {
  project: ProjectDocument;
  isTooltipOpen: boolean;
  tooltipPosition?: PlacementWithLogical;
  tooltipLabel: string;
}) {
  if (!project?.wallet?.isBalanceRequired) {
    return null;
  }

  return (
    <Tooltip
      label={tooltipLabel}
      pointerEvents={"all"}
      isOpen={isTooltipOpen}
      padding={4}
      fontSize={"md"}
      backgroundColor={"red.500"}
      placement={tooltipPosition}
      hasArrow
    >
      <Flex direction="row" alignItems="center" mb={2}>
        <Text fontSize="13" color={"descText"}>
          Have at least{" "}
          <b>
            {project?.wallet?.balance}{" "}
            {SUPPORTED_CHAINS[project?.chain as SupportedChains].currency}{" "}
          </b>{" "}
          in your wallet
        </Text>
        {isTooltipOpen && <Icon ml="2" as={FaTimesCircle} color="#CD4A38" />}
        <RequiredIndicator required={!project.wallet?.isBalanceOptional} />
      </Flex>
    </Tooltip>
  );
}
